var _resolve = {
  // 'react': require('rax/lib/compat'),
  // 'rax-image': require('rax-image'),
  // 'rax-link': require('rax-link'),
  // 'rax-text': require('rax-text'),
  // 'rax-view': require('rax-view'),
};
export var setComponentResolve = function setComponentResolve(config) {
  if (config === void 0) {
    config = null;
  }
  if (config) {
    _resolve = Object.assign({}, _resolve, config || {});
  }
  return getComponentResolve();
};
export var getComponentResolve = function getComponentResolve() {
  return _resolve;
};